"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RESIZE = exports.SCROLL = exports.ELEMENT_INTERACTION = exports.URL_CHANGE = exports.REDUX_ACTION = void 0;

var _lodash = _interopRequireDefault(require("lodash.debounce"));

var _generateId = _interopRequireDefault(require("./util/generateId"));

var _toNumber = _interopRequireDefault(require("./util/toNumber"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var REDUX_ACTION = 'REDUX_ACTION';
exports.REDUX_ACTION = REDUX_ACTION;
var URL_CHANGE = 'URL_CHANGE';
exports.URL_CHANGE = URL_CHANGE;
var ELEMENT_INTERACTION = 'ELEMENT_INTERACTION';
exports.ELEMENT_INTERACTION = ELEMENT_INTERACTION;
var SCROLL = 'SCROLL';
exports.SCROLL = SCROLL;
var RESIZE = 'RESIZE';
exports.RESIZE = RESIZE;
var alreadyRecorded = [];

var Recorder =
/**
 * @private
 */

/**
 * @private
 */

/**
 * Creates a new `Recorder` instance.
 */
function Recorder() {
  var _this = this;

  var overwriteOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _classCallCheck(this, Recorder);

  Object.defineProperty(this, "_meta", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: {}
  });
  Object.defineProperty(this, "_latestError", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: null
  });
  Object.defineProperty(this, "_initialize", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      _this._meta.id = (0, _generateId.default)();
      _this._meta.environment = String(process.env.NODE_ENV);
      _this._meta.startTime = Date.now();
      _this._meta.startUrl = document.location.href;
      _this._meta.screenWidth = window.innerWidth;
      _this._meta.screenHeight = window.innerHeight;
      _this._meta.userAgent = navigator.userAgent;
      _this._steps = [];
    }
  });
  Object.defineProperty(this, "_handleScroll", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: (0, _lodash.default)(function () {
      _this._dropLastEqualStep(SCROLL);

      _this._addStep(SCROLL, {
        yAxis: window.scrollY,
        xAxis: window.scrollX
      });
    }, 200)
  });
  Object.defineProperty(this, "_handleResize", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: (0, _lodash.default)(function () {
      _this._dropLastEqualStep(RESIZE);

      _this._addStep(RESIZE, {
        width: window.innerWidth,
        height: window.innerHeight
      });
    }, 200)
  });
  Object.defineProperty(this, "_dropLastEqualStep", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(type) {
      var lastStep = _this._steps[_this._steps.length - 1];

      if (lastStep && lastStep.type === type) {
        _this._steps = _this._steps.slice(0, -1);
        return true;
      }

      return false;
    }
  });
  Object.defineProperty(this, "_addStep", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(type, data) {
      _this._steps.push({
        type: type,
        time: Date.now(),
        data: data
      });
    }
  });
  Object.defineProperty(this, "_handleGlobalError", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(errEvent) {
      if (!errEvent.isTrusted) {
        return;
      }

      _this.captureError(errEvent);
    }
  });
  Object.defineProperty(this, "createCaptureActionMiddleware", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(shouldConsider) {
      return function () {
        return function (next) {
          return function (action) {
            if (typeof shouldConsider === 'function' && !shouldConsider(action)) {
              return next(action);
            }

            var data = _extends({}, action);

            if (_typeof(data) === 'object' && typeof data.type === 'string' && data.type.startsWith('BR_AUTH_') && _typeof(data.payload) === 'object') {
              data.payload = Object.keys(data.payload).reduce(function (accumulator, key) {
                var value = data.payload[key];

                if (['accessToken', 'refreshToken', 'user'].includes(key)) {
                  value = '<HIDDEN_BY_BR_BROWSER_ERROR>';
                }

                return _extends({}, accumulator, _defineProperty({}, key, value));
              }, {});
            }

            _this._addStep(REDUX_ACTION, data);

            return next(action);
          };
        };
      };
    }
  });
  Object.defineProperty(this, "captureURLChange", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      _this._addStep(URL_CHANGE, document.location.href);
    }
  });
  Object.defineProperty(this, "captureInteraction", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(event) {
      if (!event || !event.target || !(event.target instanceof HTMLElement)) {
        return;
      }

      if (!event.target.dataset.interactionId) {
        return;
      }

      var data = {
        interactionId: event.target.dataset.interactionId,
        textContent: null
      };

      if (event.target.textContent) {
        data.textContent = event.target.textContent;
      }

      _this._addStep(ELEMENT_INTERACTION, data);
    }
  });
  Object.defineProperty(this, "captureCustomInteraction", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(interactionId) {
      var textContent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      _this._addStep(ELEMENT_INTERACTION, {
        interactionId: interactionId,
        textContent: textContent
      });
    }
  });
  Object.defineProperty(this, "captureError", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(err, componentStackTrace) {
      if (alreadyRecorded.includes(err)) {
        console.log('Already known!', err);
        return Promise.resolve();
      }

      alreadyRecorded.push(err);
      var error = {
        message: err.message || 'Unknown error',
        stackTrace: err.stack || null,
        // $FlowFixMe
        file: err.fileName || err.filename || null,
        // $FlowFixMe
        line: (0, _toNumber.default)(err.lineNumber || err.lineno, null),
        // $FlowFixMe
        column: (0, _toNumber.default)(err.columnNumber || err.colno, null)
      };

      if (componentStackTrace) {
        // $FlowFixMe
        error.componentStackTrace = componentStackTrace;
      }

      var isProduction = _this._meta.environment === 'production';
      var journey = {
        meta: _extends({}, _this._meta, {
          endTime: Date.now()
        }),
        error: error,
        steps: _this._steps
      };
      _this._latestError = error;
      console.log('Journey recorded (type "copy(__JOURNEY__)" to copy it to the clipboard!');
      window.__JOURNEY__ = journey;

      if (!isProduction) {
        return Promise.resolve();
      }

      return fetch('https://error.br.de', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(journey)
      }).then(function (res) {
        _this._initialize();

        if (res.status !== 200) {
          console.log('unable to log client-error');
        }

        return journey;
      });
    }
  });
  Object.defineProperty(this, "getId", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      return String(_this._meta.id);
    }
  });
  Object.defineProperty(this, "getLatestError", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      return _this._latestError;
    }
  });
  Object.defineProperty(this, "stop", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      window.removeEventListener('scroll', _this._handleScroll);
      window.removeEventListener('resize', _this._handleResize);
      window.removeEventListener('error', _this._handleGlobalError);
    }
  });

  var options = _extends({
    registerGlobalErrorHandler: false
  }, overwriteOptions);

  if (options.name) {
    this._meta.name = options.name;
  }

  if (options.version) {
    this._meta.version = options.version;
  }

  this._initialize();

  window.addEventListener('scroll', this._handleScroll);
  window.addEventListener('resize', this._handleResize);

  if (options.registerGlobalErrorHandler) {
    window.addEventListener('error', this._handleGlobalError);
  }
};

exports.default = Recorder;